import type { FC } from 'react';

import { Form } from '../Form.tsx';
import type { GenericFormProps } from '../GenericFormProps.ts';
import { Email } from './Email.tsx';
import { schema } from './schema.ts';

export const EmailForm: FC<GenericFormProps<typeof Email, typeof schema>> = ({ onSubmit, buttonSlot }) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={{ email: '' }}
    formContentElement={Email}
    schema={schema}
    onSubmit={onSubmit}
  />
);
